import { defineRecipe } from '@chakra-ui/react/styled-system'

import { EColors } from '../types'

const { white, skeletonGray } = EColors

export const skeletonRecipe = defineRecipe({
  className: 'chakra-skeleton',
  base: {
    borderRadius: '8px',
    '--skeleton-start-color': skeletonGray,
    '--skeleton-end-color': white,
    background: 'var(--skeleton-start-color)',
    borderColor: 'var(--skeleton-end-color)',
  },
  variants: {
    variant: {
      primary: {},
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
})
